<template>
    <div id="map" ref="Map"></div>
</template>

<script>
    import options from './../../../../utils/options'
    import echarts from 'echarts'
    import {getProvincials} from '../../../../network/utils'

    export default {
        name: "isProvinceMap",
        props: ['provincialsData', 'activeUnitName', 'activeUnitProvince'],

        data() {
            return {
                chartMap: '',
                optionMap: options.optionMigrateMap,
                dataInfo: [],
                provinceList: [
                    '广东', '广西', '海南', '云南', '贵州', '湖南', '福建', '江西', '浙江', '安徽', '江苏', '湖北', '河南',
                    '上海', '山东', '河北', '山西', '天津', '北京', '辽宁', '吉林', '黑龙江', '内蒙古', '新疆', '甘肃', '宁夏',
                    '陕西', '重庆', '四川', '青海', '西藏'],
            }
        },

        methods: {
            chartInit() {
                this.chartMap = echarts.init(this.$refs.Map);
                this.chartMap.showLoading();
                this.optionMap.series[1].data = this.dataInfo.dataLines;
                this.optionMap.title.text = this.dataInfo.unitName + '--异地项目分布情况';

                this.optionMap.series[1].data = this.dataInfo.dataLines;
                this.optionMap.visualMap.min = this.dataInfo.minNum;
                this.optionMap.visualMap.max = this.dataInfo.maxNum;
                this.optionMap.series[2].name = this.dataInfo.unitName;
                this.optionMap.series[2].data = this.dataInfo.dataScatterArea;
                this.optionMap.series[3].data = this.dataInfo.dataScatterUnit;
                this.chartMap.hideLoading();
                this.chartMap.setOption(this.optionMap, true);
            },

            formatDate(val) {
                let dataLines = [];
                let dataScatterUnit = [];
                let dataScatterArea = [];
                let unitName = this.activeUnitName;
                let geoCoordMap = {
                    '上海': [119.1803, 31.2891],
                    "福建": [119.4543, 25.9222],
                    "重庆": [108.384366, 30.439702],
                    '北京': [116.4551, 40.2539],
                    "辽宁": [123.1238, 42.1216],
                    "河北": [114.4995, 38.1006],
                    "天津": [117.4219, 39.4189],
                    "山西": [112.3352, 37.9413],
                    "陕西": [109.1162, 34.2004],
                    "甘肃": [103.5901, 36.3043],
                    "宁夏": [106.3586, 38.1775],
                    "青海": [101.4038, 36.8207],
                    "新疆": [87.9236, 43.5883],
                    "西藏": [91.11, 29.97],
                    "四川": [103.9526, 30.7617],
                    "吉林": [125.8154, 44.2584],
                    "山东": [117.1582, 36.8701],
                    "河南": [113.4668, 34.6234],
                    "江苏": [118.8062, 31.9208],
                    "安徽": [117.29, 32.0581],
                    "湖北": [114.3896, 30.6628],
                    "浙江": [119.5313, 29.8773],
                    '内蒙古': [110.3467, 41.4899],
                    "江西": [116.0046, 28.6633],
                    "湖南": [113.0823, 28.2568],
                    "贵州": [106.6992, 26.7682],
                    "云南": [102.9199, 25.4663],
                    "广东": [113.12244, 23.009505],
                    "广西": [108.479, 23.1152],
                    "海南": [110.3893, 19.8516],
                    '黑龙江': [127.9688, 45.368],
                    '台湾': [121.4648, 25.5630]
                };
                let AreaData = [];
                for (let i of val) {
                    if (this.activeUnitProvince !== i['city__province__city']){
                        AreaData.push({name: i['city__province__city'], value: i['number']})
                    }
                }
                let minNum = 0;
                let maxNum = AreaData[AreaData.length - 1].value;
                if (maxNum < 20) {
                    maxNum = 20
                }
                geoCoordMap[unitName] = geoCoordMap[this.activeUnitProvince];

                let dataFormat = [];

                AreaData.map((item) => {
                    let arr = [];
                    arr.push({
                        name: unitName
                    });
                    arr.push(item);
                    dataFormat.push(arr)
                });

                let convertData = function(data) {
                    let res = [];
                    for (let i = 0; i < data.length; i++) {
                        let dataItem = data[i];
                        let fromCoord = geoCoordMap[dataItem[0].name];
                        let toCoord = geoCoordMap[dataItem[1].name];
                        if (fromCoord && toCoord) {
                            res.push({
                                fromName: dataItem[0].name,
                                toName: dataItem[1].name,
                                coords: [fromCoord, toCoord],
                                value: dataItem[1].value
                            });
                        }
                    }
                    return res;
                };
                dataLines = convertData(dataFormat);

                dataScatterArea = dataFormat.map(function(dataItem) {
                    return {
                        name: dataItem[1].name,
                        value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value]).concat(maxNum),
                    };
                });
                dataScatterUnit = [{
                    name: unitName,
                    value: geoCoordMap[unitName],
                    visualMap: false
                }];
                return {unitName, dataLines, dataScatterArea, dataScatterUnit, maxNum, minNum}
            },
        },

        watch: {
            provincialsData: {
                handler(val) {
                    if (val.length > 1) {
                          this.dataInfo = this.formatDate(val)
                    }
                },
                deep: true,
            },
            dataInfo: {
                handler() {
                    this.chartInit();
                },
                deep: true,
            },

        },
    }

</script>

<style scoped>
    #map {
        height: 70vh;
        background-color: #442f4a;
        opacity: 0.9;
        position: relative;
    }
</style>